<template>
  <div class="my-layout-box">
    <!-- 基本信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>基本信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>付汇单号: </span>
            <i class="c-code-color">{{ items.Code }}</i>
          </li>
          <li>
            <span>付汇状态: </span>
            <i :class="items.Status == 0? 'c-one-color': items.Status ==1? 'c-two-color': 'c-four-color'">{{ items.StatusStr }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>付款金额: </span>
            <i class="c-amount-color">{{ items.LastPaymentAmount }} </i>{{ items.CurrencyType }}
          </li>
          <li>
            <span>付款币别: </span>
            <i>{{ items.CurrencyType }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收款人: </span>
            <i>{{ items.SupplierName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>SWIFT CODE： </span>
            <i>{{ items.TT_SwiftCode }} </i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收款账户：</span>
            <i>{{ items.TT_Account }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收款银行：</span>
            <i>{{ items.TT_BankName }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>收款银行地址： </span>
            <i>{{ items.TT_Address }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>付款方式： </span>
            <i class="c-one-color">{{ items.SettlementMode == 1 ? "T.T(转账)" : "" }}</i>
          </li>
          <li>
            <span>手续费承担: </span>
            <i>{{ items.ChargeString }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 公司信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>申请付款列表</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>
      </section>
    </section>

    <section class="c-box">
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>当前付汇汇率: </span>
            <i>{{ items.SettlementRate }}</i>
          </li>
          <li>
            <span>本次付汇人民币:</span>
            <i class="c-unAmount-color">{{ items.PaySCAmount }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>付汇银行手续费: </span>
            <i class='c-unAmount-color'>{{ items.BankCharges }} </i>
          </li>
          <li>
            <span>合计金额:</span>
            <i class="c-amount-color">{{ items.SCAmount }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 开票信息 -->
    <section class="c-box">
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>请将以上应付款项按如下方式付至我司银行账户</span>
            <i></i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>公司名称: </span>
            <i>深圳市正能量供应链服务有限公司</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>1. 开户行: </span>
            <i>中国建设银行股份有限公司深圳智慧支行</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>账号: </span>
            <i>44250110379800001615</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>2. 开户行: </span>
            <i>中国交通银行股份有限公司华强支行</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>账号: </span>
            <i>43066436012018100436</i>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>
<script>
import { getRemittanceDetail } from "~/api/finance";
import { itemsDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
const ChargeTypeOption = {
  3: "客户承担",
  2: "供应商承担",
  1: "共同承担"
};
const statusOption = {
  0: "待提交",
  1: "待审核",
  2: "已审核"
};
export default {
  name: "orderContractDetail",
  components: {
    DetailList
  },
  data() {
    return {
      items: {},
      listMap: itemsDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        Id: id
      };
      let data = await getRemittanceDetail(params);
      data.ChargeString = ChargeTypeOption[data.ChargeType] || "";
      data.StatusStr = statusOption[data.Status] || "";
      data.Lines.forEach(line => {
        line.CurrencyType = data.CurrencyType;
      });
      this.items = data;
      this.$refs.detailList.getList(data.Lines);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
